export default {
  name: 'Notification',
  selector: '.Notification',
  validInnerComponents: [
    'Text',
    'Link',
    'Icon',
    'Border',
    'Avatar',
    'PollGraph',
  ],
  defaultRules: [],
}
